export default "__VITE_ASSET__D8$LG6J1__"